import React from "react";
import { CardHeader, Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { LoadingButton } from "@mui/lab";
import { useSelector } from "react-redux";

const SocialNetworkingLinks = (props) => {
  const {
    shopWebsiteConfig,
    handleChange,
    handleSave,
    handleRestore,
    loadingButton,
  } = props?.shopWebsiteCustomization;
  const data = shopWebsiteConfig?.SocialNetworks;

  const { profile } = useSelector((state) => state);
  const isSocialLinksEditable = ["Super Admin", "Admin", "Director(FC Lead)", "Franchise Consultant"].includes(profile.role);

  return (
    <Card className="bg-white shadow-sm">
      <CardHeader
        title={
          <div className="text-[#24211F] text-base font-bold">
            Social Networking Links
          </div>
        }
      ></CardHeader>
      <div style={{ border: "1px solid #ccc"}}>
        <CardContent>
          <Grid container gap={1}>
            <Grid item xs={12}>
              <div className="flex justify-between">
                <div className="flex justify-start w-6/12">
                  <img
                    src={"../../assets/images/meta-icon.svg"}
                    alt="Facebook"
                    width={"22px"}
                    height={"22px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    Meta <sub className="flex items-center">(Facebook)</sub>
                  </p>
                </div>
                <div className="w-full">
                  <TextField
                    disabled={!isSocialLinksEditable}
                    fullWidth
                    variant="outlined"
                    value={data?.vchFaceBookURL}
                    name="vchFaceBookURL"
                    id="vchFaceBookURL"
                    placeholder="Enter URL"
                    onChange={(e) =>
                      handleChange(
                        "SocialNetworks",
                        "vchFaceBookURL",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-between">
                <div className="flex justify-start w-6/12">
                  <img
                    src={"../../assets/images/ig-instagram-icon.svg"}
                    alt="Instagram"
                    width={"22px"}
                    height={"22px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    Instagram
                  </p>
                </div>
                <div className="w-full">
                  <TextField
                    disabled={!isSocialLinksEditable}
                    fullWidth
                    variant="outlined"
                    value={data?.vchInstagramURL}
                    name="vchInstagramURL"
                    id="vchInstagramURL"
                    placeholder="Enter URL"
                    onChange={(e) =>
                      handleChange(
                        "SocialNetworks",
                        "vchInstagramURL",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-between">
                <div className="flex justify-start w-6/12">
                  <img
                    src={"../../assets/images/twitterlogo.svg"}
                    alt="twitter"
                    width={"22px"}
                    height={"22px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    Twitter
                  </p>
                </div>
                <div className="w-full">
                  <TextField
                    disabled={!isSocialLinksEditable}
                    fullWidth
                    variant="outlined"
                    value={data?.vchTwitterURL}
                    name="vchTwitterURL"
                    id="vchTwitterURL"
                    placeholder="Enter URL"
                    onChange={(e) =>
                      handleChange(
                        "SocialNetworks",
                        "vchTwitterURL",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </div>
      <CardActions
        sx={{ backgroundColor: "#FFF8F8", borderTop: "1px solid #C12637",height:'50px' }}
      >
        <Grid container >
          <Grid item xs={6}>
            <Button
              disabled={!isSocialLinksEditable}
              className="text-[#24211F] font-semibold"
              onClick={() => handleRestore("SocialNetworks")}
            >
              Restore
            </Button>
          </Grid>
          <Grid item xs={6} container justifyContent={{ xs: "right" }}>
            <LoadingButton
              variant="outlined"
              disabled={(loadingButton === "SocialNetworks" || !isSocialLinksEditable) ? true : false}
              loading={loadingButton === "SocialNetworks" ? true : false}
              onClick={() => handleSave("SocialNetworks")}
              className="text-[#C12637] font-semibold bg-white border-[#C12637]"
            >
              Save
            </LoadingButton>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default SocialNetworkingLinks;
